import { render, staticRenderFns } from "./UpdateProduct.vue?vue&type=template&id=843cad6c&scoped=true&"
import script from "./UpdateProduct.vue?vue&type=script&lang=js&"
export * from "./UpdateProduct.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProduct.vue?vue&type=style&index=0&id=843cad6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843cad6c",
  null
  
)

component.options.__file = "UpdateProduct.vue"
export default component.exports